import { Box, Tooltip } from "@mui/material";
import styles from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useState } from "react";

interface JsonViewerProps {
  data: any
}

export const JsonViewer = ({data}: JsonViewerProps) =>  {
  const manifestData = JSON.stringify(data, null, 2);
  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => setOpen(false);
  const handleCopy = async () => {
    await navigator.clipboard.writeText(manifestData);
    setOpen(true);
  }
  
  return (
    <Box className={styles.container}>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip 
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="left"
          title="Copied to Clipboard"
        >
            <FontAwesomeIcon icon={faCopy}
              id="copy-manifest-button"
              data-testid="copy-manifest-btn"
              className={styles.copyToClipBoardButton}
              onClick={handleCopy}
            />
          </Tooltip>
      </ClickAwayListener>
    
      <pre>
        {manifestData}
      </pre>
    </Box>
  )
};
